import React, { createContext, useContext, useState, ReactNode } from "react";

// Define the state interface
interface AppState {
  showCookieSettings: boolean | null; // Example state for user
}

// Define the context interface
interface AppContextType {
  state: AppState;
  updateState: (key: keyof AppState, value: AppState[keyof AppState]) => void;
}

// Create the context with a default value of undefined
const AppContext = createContext<AppContextType | undefined>(undefined);

// Provider component props interface
interface AppProviderProps {
  children: ReactNode;
}

// Create the provider component
export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  const [state, setState] = useState<AppState>({
    showCookieSettings: false,
  });

  const updateState = (
    key: keyof AppState,
    value: AppState[keyof AppState],
  ) => {
    setState((prevState) => ({ ...prevState, [key]: value }));
  };

  return (
    <AppContext.Provider value={{ state, updateState }}>
      {children}
    </AppContext.Provider>
  );
};

// Custom hook to use the context
export const useAppContext = (): AppContextType => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within an AppProvider");
  }
  return context;
};
